import {
  GET_CASH_UP,
  GET_CASH_UP_REPORTS,
  GET_SET_CASHIER_BOX,
  GET_SET_DISCOUNTS,
  GET_SET_DISCOUNT_CODES,
  GET_SET_INVENTORY,
  GET_SET_PRODUCTS,
  GET_SET_SECTIONS,
  GET_SET_SUPPLY,
  GET_STORES
} from '../utils/api';
import { delData, getData, postData, putData } from '../utils/api-service';
import { IInOutMovement, IStore } from '../interfaces/Store';
import WashdayClientSingleton from './WashdayClientSingleton';
import type { AxiosResponse } from 'axios';
import type { CopyStoreLoyaltySettingsPayload } from 'washday-sdk';

export const copyLoyaltySettings = (storeId: string, data: CopyStoreLoyaltySettingsPayload) =>
  WashdayClientSingleton.getInstance().stores.copyLoyaltySettings(storeId, data);

export interface AddCashierBoxMovementV2Payload {
  type: string;
  date: Date;
  amount: number;
  notes?: string;
  paymentMethod: string;
}

export interface AddCashierBoxMovementV2Response {
  data: IInOutMovement;
  errors?: unknown;
}
export const updateDiscountCodeByIdV2 = async (storeId: string, discountId: string, data: {
  products?: string[];
  buyAndGetConditions?: any;
  freeProductSetting?: any;
  name?: string;
  code?: string;
  fromDate?: string;
  toDate?: string;
}) => {
  try {
    return await WashdayClientSingleton.getInstance().discountCodes.updateDiscountCodeById(storeId, discountId, data);
  } catch (e) {
    console.log('ERROR createDiscountCodeV2', e);
    throw e;
  }
};

export const deleteDiscountCodeByIdV2 = async (storeId: string, discountId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().discountCodes.deleteDiscountCodeById(storeId, discountId);
  } catch (e) {
    console.log('ERROR createDiscountCodeV2', e);
    throw e;
  }
};

export const createDiscountCodeV2 = async (storeId: string, data: any) => {
  try {
    return await WashdayClientSingleton.getInstance().discountCodes.createDiscountCode(storeId, data);
  } catch (e) {
    console.log('ERROR createDiscountCodeV2', e);
    throw e;
  }
};

export const verifyDiscountCodeV2 = async (
  storeId: string,
  code: string,
  params?: { orderSubtotal?: number; currentDate?: string },
) => {
  try {
    return await WashdayClientSingleton.getInstance().discountCodes.verifyDiscountCode(storeId, code, params);
  } catch (e) {
    console.log('ERROR getDiscountCodesV2', e);
    throw e;
  }
};

export const getDiscountCodeByIdV2 = async (storeId: string, discountId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().discountCodes.getDiscountCodeById(storeId, discountId);
  } catch (e) {
    console.log('ERROR getDiscountCodesV2', e);
    throw e;
  }
};

export const getDiscountCodesV2 = async (storeId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().discountCodes.getDiscountCodes(storeId);
  } catch (e) {
    console.log('ERROR getDiscountCodesV2', e);
    throw e;
  }
};

export const createAutomaticDiscountV2 = async (storeId: string, data: any) => {
  try {
    return await WashdayClientSingleton.getInstance().automaticDiscount.createAutomaticDiscount(storeId, data);
  } catch (e) {
    console.log('ERROR createAutomaticDiscountV2', e);
    throw e;
  }
};

export const updateAutomaticDiscountByIdV2 = async (storeId: string, discountId: string, data: {
  products: string[];
}) => {
  try {
    return await WashdayClientSingleton.getInstance().automaticDiscount.updateAutomaticDiscountById(storeId, discountId, data);
  } catch (e) {
    console.log('ERROR updateAutomaticDiscountById', e);
    throw e;
  }
};


export const deleteAutomaticDiscountByIdV2 = async (storeId: string, discountId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().automaticDiscount.deleteAutomaticDiscountById(storeId, discountId);
  } catch (e) {
    console.log('ERROR deleteAutomaticDiscountByIdV2', e);
    throw e;
  }
};

export const getAutomaticDiscountByIdV2 = async (storeId: string, discountId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().automaticDiscount.getAutomaticDiscountById(storeId, discountId);
  } catch (e) {
    console.log('ERROR getDiscountCodesV2', e);
    throw e;
  }
};

export const getAutomaticDiscountsV2 = async (storeId: string, queryParams?: { currentDate?: string }) => {
  try {
    return await WashdayClientSingleton.getInstance().automaticDiscount.getAutomaticDiscounts(storeId, queryParams);
  } catch (e) {
    console.log('ERROR getAutomaticDiscountsV2', e);
    throw e;
  }
};

export const getAvailableAutomaticDiscountsV2 = async (storeId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().automaticDiscount.getAvailableAutomaticDiscounts(storeId);
  } catch (e) {
    console.log('ERROR getAvailableAutomaticDiscountsV2', e);
    throw e;
  }
};

export const getStoreReviewLink = async (storeId: string) => {
  try {
    if (!storeId || storeId.trim().length === 0) {
      throw Error('Id de sucursal requerido');
    }
    const res = await WashdayClientSingleton.getInstance().stores.getStoreReviewLink(storeId);
    return res?.data?.data;
  } catch (e) {
    console.log('ERROR getStoresV2', e);
    throw e;
  }
};

export const copyStoreV2 = async (storeId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().stores.copyStore(storeId);
  } catch (e) {
    console.log('ERROR copyStoreV2', e);
    throw e;
  }
};

export const createStoreV2 = async (data: IStore) => {
  try {
    return await WashdayClientSingleton.getInstance().stores.createStore(data);
  } catch (e) {
    console.log('ERROR getStoresV2', e);
    throw e;
  }
};

export const createCashierBoxV2 = async (storeId: string, data: { name: string }) => {
  try {
    return await WashdayClientSingleton.getInstance().cashierboxes.createCashierBox(storeId, data);
  } catch (e) {
    console.log('ERROR createCashierBoxV2', e);
    throw e;
  }
};

export const updateCashierBoxByIdV2 = async (storeId: string, cashierboxId: string, data: { name: string }) => {
  try {
    return await WashdayClientSingleton.getInstance().cashierboxes.updateCashierBoxById(storeId, cashierboxId, data);
  } catch (e) {
    console.log('ERROR createCashierBoxV2', e);
    throw e;
  }
};

export const addCashierBoxMovementV2 = async (
  storeId: string,
  cashierboxId: string,
  data: AddCashierBoxMovementV2Payload,
): Promise<AxiosResponse<AddCashierBoxMovementV2Response>> => {
  try {
    return await WashdayClientSingleton.getInstance().cashierboxes.addCashierBoxMovement(storeId, cashierboxId, data);
  } catch (e) {
    console.log('ERROR addCashierBoxMovementV2', e);
    throw e;
  }
};

export const getCashierBoxMovementsHistoryV2 = async (storeId: string, cashierboxId: string, params: {
  pageNum: number,
  limit: number
}) => {
  try {
    return await WashdayClientSingleton.getInstance().cashierboxes.getCashierBoxMovementsHistory(storeId, cashierboxId, params);
  } catch (e) {
    console.log('ERROR getCashierBoxMovementsHistoryV2', e);
    throw e;
  }
};

export const getCashierBoxesV2 = async (storeId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().cashierboxes.getCashierboxesByStoreId(storeId);
  } catch (e) {
    console.log('ERROR getCashierBoxesV2', e);
    throw e;
  }
};

export const getCashierboxesByIdV2 = async (storeId: string, cashierboxId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().cashierboxes.getCashierboxesById(storeId, cashierboxId);
  } catch (e) {
    console.log('ERROR getCashierboxesByIdV2', e);
    throw e;
  }
};

export const deleteCashierBoxByIdV2 = async (storeId: string, cashierboxId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().cashierboxes.deleteCashierBoxById(storeId, cashierboxId);
  } catch (e) {
    console.log('ERROR deleteCashierBoxByIdV2', e);
    throw e;
  }
};

export const deleteCashierBoxMovementById = async ({
  storeId, cashierBoxId, movementId
}: {
  storeId: string,
  cashierBoxId: string,
  movementId: string
}) => {
  try {
    return await WashdayClientSingleton.getInstance().cashierboxes.deleteCashierBoxMovementById({ storeId, cashierBoxId, movementId });
  } catch (e) {
    console.log('ERROR deleteCashierBoxMovementById', e);
    throw e;
  }
};

export const getStoresV2 = async (isActive = true) => {
  try {
    return await WashdayClientSingleton.getInstance().stores.getStores({
      isActive
    });
  } catch (e) {
    console.log('ERROR getStoresV2', e);
    throw e;
  }
};

export const getStoreAssignableStaffV2 = async (
  storeID: string,
  query: string | {
    appendAdmin?: string,
    storeIds?: string[] | string,
  } = ''
) => {
  try {
    const res = await WashdayClientSingleton.getInstance().staff.getStoreAssignableStaffs(
      storeID,
      query
    );
    return { ...res.data };
  } catch (e) {
    console.log('ERROR getStoreAssignableStaffV2', e);
    throw e;
  }
};

export const getStoreByIdV2 = async (storeID: string) => {
  try {
    return await WashdayClientSingleton.getInstance().stores.getStoreById(storeID);
  } catch (e) {
    console.log('ERROR getStoreByIdV2', e);
    throw e;
  }
};

export const getStoreImagesV2 = async (storeID: string) => {
  try {
    return await WashdayClientSingleton.getInstance().stores.getStoreImages(storeID);
  } catch (e) {
    console.log('ERROR getStoreImagesV2', e);
    throw e;
  }
};


export const updateStoreByIdV2 = async (storeID: string, data: IStore) => {
  try {
    const res = await WashdayClientSingleton.getInstance().stores.updateStoreById(storeID, data);
    return { ...res.data };
  } catch (e) {
    console.log('ERROR updateStoreByIdV2', e);
    throw e;
  }
};

export const deleteStoreByIdV2 = async (storeID: string) => {
  try {
    const res = await WashdayClientSingleton.getInstance().stores.deleteStoreById(storeID);
    return { ...res.data };
  } catch (e) {
    console.log('ERROR deleteStoreByIdV2', e);
    throw e;
  }
};

export const productBulkImportByStoreV2 = async (storeID: string, data: FormData) => {
  try {
    const res = await WashdayClientSingleton.getInstance().products.bulkImport(storeID, data);
    return { ...res.data };
  } catch (e) {
    console.log('ERROR productBulkImportByStoreV2', e);
    throw e;
  }
};

/** @deprecated Use `productBulkImportByStoreV2`. */
export const productBulkByStoreV2 = productBulkImportByStoreV2;

export const createStoreImageV2 = async (storeID: string, data: FormData) => {
  try {
    const res = await WashdayClientSingleton.getInstance().stores.createStoreImage(data);
    return { ...res.data };
  } catch (e) {
    console.log('ERROR productBulkByStoreV2', e);
    throw e;
  }
};

export const getStores = async (isActive = true, t = () => { }) => {
  try {
    const res = await getData(`${GET_STORES}?isActive=${isActive}`, null, t);
    return res?.data?.data?.stores || [];
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const getCashierBoxesByStore = async (storeId, t = () => { }) => {
  try {
    let res = await getData(`${GET_SET_CASHIER_BOX(storeId)}`);
    return res?.data?.data?.cashierBoxes || [];
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return [];
  }
};

export const deleteCashierBox = async (storeID, cashierBoxID, t = () => { }) => {
  try {
    const res = await delData(
      `${GET_SET_CASHIER_BOX(storeID)}/${cashierBoxID}`,
      {},
      null,
      t('alerts.success')
    );
    return res?.data;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return null;
  }
};

export const addCashierBoxMovement = async (storeID, cashierBoxID, postObj, t = () => { }) => {
  try {
    const res = await postData(
      `${GET_SET_CASHIER_BOX(storeID)}/${cashierBoxID}/add-movement`,
      postObj,
      null,
      t('alerts.success'),
      null,
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return false;
  }
};

export const getCashierBoxActivity = async (storeID, cashierBoxID, page = 0, t = () => { }) => {
  try {
    const res = await getData(
      `${GET_SET_CASHIER_BOX(storeID)}/${cashierBoxID}/history?pageNum=${page}&limit=10`,
      null,
      t
    );
    if (!res?.data?.data) {
      return { inOutMovements: [], totalRows: 0 };
    }
    return {
      inOutMovements: res?.data?.data.history,
      totalRows: res?.data?.data.totalRow
    };
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return { inOutMovements: [], totalRows: 0 };
  }
};

export const getActiveStores = async (t = () => { }) => {
  try {
    return await getData(`${GET_STORES}?isActive=true`);
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const getSectionsByStore = async (storeID, extraParams = '', t = () => { }) => {
  try {
    return await getData(`${GET_SET_SECTIONS}?store=${storeID}&isActive=true&${extraParams}`);
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const getSectionById = async (sectionId, t = () => { }) => {
  try {
    return await getData(`${GET_SET_SECTIONS}/${sectionId}`);
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const createSection = async (postObj, t = () => { }) => {
  try {
    const res = await postData(
      GET_SET_SECTIONS,
      postObj,
      null,
      t('alerts.success'),
      'application/json',
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const updateSectionById = async (sectionId, putObj, t) => {
  try {
    const res = await putData(
      `${GET_SET_SECTIONS}/${sectionId}`,
      putObj,
      null,
      t('alerts.success'),
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const createProduct = async (postObj, t = () => { }) => {
  try {
    const res = await postData(
      GET_SET_PRODUCTS,
      postObj,
      null,
      t('alerts.success'),
      'application/json',
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const getProductById = async (productID, t = () => { }) => {
  try {
    return await getData(`${GET_SET_PRODUCTS}/${productID}`, null, t);
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const getInventoryByID = async (storeID, inventoryID, t = () => { }) => {
  try {
    const res = await getData(`${GET_SET_INVENTORY(storeID)}/${inventoryID}`, null, t);
    return res.data.data;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return {};
  }
};

export const updateInventoryByID = async (storeID, inventoryID, putObj, t) => {
  try {
    const res = await putData(
      `${GET_SET_INVENTORY(storeID)}/${inventoryID}`,
      putObj,
      null,
      t('alerts.success'),
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return false;
  }
};

export const createInventory = async (storeID, postObj, t = () => { }) => {
  try {
    const res = await postData(`${GET_SET_INVENTORY(storeID)}`, postObj, null, t('alerts.success'));
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return false;
  }
};

export const getInventoryByStore = async (storeID, extraParams = '', t = () => { }) => {
  try {
    const res = await getData(`${GET_SET_INVENTORY(storeID)}?${extraParams}`);
    return res?.data?.data?.inventory || [];
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return [];
  }
};

export const deleteInventory = async (storeID, inventoryID, t = () => { }) => {
  try {
    const res = await delData(
      `${GET_SET_INVENTORY(storeID)}/${inventoryID}`,
      {},
      null,
      t('alerts.success')
    );
    return res?.data;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return null;
  }
};

export const addInventoryStock = async (storeID, inventoryID, putObj, t) => {
  try {
    const res = await putData(
      `${GET_SET_INVENTORY(storeID)}/${inventoryID}/add-stock`,
      putObj,
      null,
      t('alerts.success'),
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return false;
  }
};

export const getInventoryHistory = async (storeID, inventoryID, page = 0, t = () => { }) => {
  try {
    const res = await getData(
      `${GET_SET_INVENTORY(storeID)}/${inventoryID}/history?pageNum=${page}&limit=10`,
      null,
      t
    );
    if (!res?.data?.data) {
      return { stockActivityHistory: [], totalRows: 0 };
    }
    return {
      stockActivityHistory: res?.data?.data.history,
      totalRows: res?.data?.data.totalRow
    };
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return { stockActivityHistory: [], totalRows: 0 };
  }
};

export const getSuppliesByStore = async (storeID, extraParams = '', t = () => { }) => {
  try {
    const res = await getData(`${GET_SET_SUPPLY(storeID)}?${extraParams}`);
    return res?.data?.data?.supplies?.supplies || [];
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return [];
  }
};

export const addStockSupply = async (storeID, supplyID, putObj, t) => {
  try {
    const res = await putData(
      `${GET_SET_SUPPLY(storeID)}/${supplyID}/addStock`,
      putObj,
      null,
      t('alerts.success'),
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return false;
  }
};

export const updatesupplyByID = async (storeID, supplyID, putObj, t) => {
  try {
    const res = await putData(
      `${GET_SET_SUPPLY(storeID)}/${supplyID}`,
      putObj,
      null,
      t('alerts.success'),
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const getSupplyByID = async (storeID, supplyID, t = () => { }) => {
  try {
    return await getData(`${GET_SET_SUPPLY(storeID)}/${supplyID}`, null, t);
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const getSupplyHistory = async (storeID, supplyID, page = 0, t = () => { }) => {
  try {
    const res = await getData(
      `${GET_SET_SUPPLY(storeID)}/${supplyID}/history?pageNum=${page}&limit=10`,
      null,
      t
    );
    if (!res?.data?.data) {
      return { supplyActivityHistory: [], totalRows: 0 };
    }
    return {
      supplyActivityHistory: res?.data?.data.history,
      totalRows: res?.data?.data.totalRow
    };
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return { supplyActivityHistory: [], totalRows: 0 };
  }
};

export const deleteSupply = async (storeID, supplyID, t = () => { }) => {
  try {
    const res = await delData(
      `${GET_SET_SUPPLY(storeID)}/${supplyID}`,
      {},
      null,
      t('alerts.success')
    );
    return res?.data;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return null;
  }
};

export const createSupply = async (storeID, postObj, t = () => { }) => {
  try {
    const res = await postData(`${GET_SET_SUPPLY(storeID)}`, postObj, null, t('alerts.success'));
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const createCashierBox = async (storeID, postObj, t = () => { }) => {
  try {
    const res = await postData(
      `${GET_SET_CASHIER_BOX(storeID)}`,
      postObj,
      null,
      t('alerts.success'),
      'application/json',
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return false;
  }
};

export const updateCashierBoxByID = async (storeID, cashierBoxID, putObj, t) => {
  try {
    const res = await putData(
      `${GET_SET_CASHIER_BOX(storeID)}/${cashierBoxID}`,
      putObj,
      null,
      t('alerts.success'),
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return false;
  }
};

export const getCashierboxById = async (storeID, cashierBoxID, t = () => { }) => {
  try {
    return await getData(`${GET_SET_CASHIER_BOX(storeID)}/${cashierBoxID}`, null, t);
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const createStore = async (postObj, t = () => { }) => {
  try {
    const res = await postData(
      GET_STORES,
      postObj,
      null,
      t('alerts.success'),
      'application/json',
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const updateStoreByID = async (storeID, putObj, t) => {
  try {
    const res = await putData(`${GET_STORES}/${storeID}`, putObj, null, t('alerts.success'), t);
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const getStoreByID = async (storeID, t = () => { }) => {
  try {
    return await getData(`${GET_STORES}/${storeID}`, null, t);
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const createDiscountByStore = async (storeID, postObj, t = () => { }) => {
  try {
    const res = await postData(
      `${GET_SET_DISCOUNTS}/${storeID}`,
      postObj,
      null,
      t('alerts.success'),
      'application/json',
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const getDiscountByID = async (storeID, discountID, t = () => { }) => {
  try {
    return await getData(`${GET_SET_DISCOUNTS}/${storeID}/${discountID}`, null, t);
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const createCashUpReport = async (storeID, cashierBoxID, postObj, t = () => { }) => {
  try {
    const res = await postData(
      `${GET_CASH_UP}/${storeID}/${cashierBoxID}`,
      postObj,
      null,
      t('alerts.success'),
      'application/json',
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const getCalculatedCashUpData = async (storeID, cashierBoxID, t = () => { }) => {
  try {
    return await getData(`${GET_CASH_UP}/${storeID}/${cashierBoxID}`, null, t);
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const getCashUpReportByID = async (storeID, cashierBoxID, t = () => { }) => {
  try {
    return await getData(`${GET_CASH_UP_REPORTS}/${storeID}/${cashierBoxID}`, null, t);
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const createDiscountCodeByStore = async (storeID, postObj, t = () => { }) => {
  try {
    const res = await postData(
      `${GET_SET_DISCOUNT_CODES}/${storeID}`,
      postObj,
      null,
      t('alerts.success'),
      'application/json',
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const getDiscountCodeByID = async (storeID, discountCodeID) => {
  try {
    return await getData(`${GET_SET_DISCOUNT_CODES}/${storeID}/${discountCodeID}`);
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const verifyDiscountCode = async (storeID, code, t = () => { }) => {
  try {
    return await getData(`${GET_SET_DISCOUNT_CODES}/${storeID}/${code}/verify`, null, t);
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const productBulkByStore = async (storeID, putObj, t = () => { }) => {
  try {
    const res = await putData(
      `${GET_SET_PRODUCTS}/${storeID}/bulk`,
      putObj,
      null,
      t('alerts.success'),
      t
    );
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};


export const bulkUpdateProductPrices = async (data: {
  storeId: string,
  section: 'all' | string;
  value: number;
}) => {
  try {
    return await WashdayClientSingleton.getInstance().products.bulkUpdateProductPrices(data);
  } catch (e) {
    console.log('ERROR productBulkPriceUpdateByStore', e);
    throw e;
  }
};

export const getOrderSequence = async (storeId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().stores.getOrderSequence(storeId);
  } catch (e) {
    console.log('ERROR getOrderSequence', e);
    throw e;
  }
};

export const setOrderSequence = async (storeId: string, data: { currentSequence: number }) => {
  try {
    return await WashdayClientSingleton.getInstance().stores.setOrderSequence(storeId, data);
  } catch (e) {
    console.log('ERROR setOrderSequence', e);
    throw e;
  }
};

export const getPaymentFees = async (storeId: string) => {
  try {
    return await WashdayClientSingleton.getInstance().stores.getPaymentFees(storeId);
  } catch (e) {
    console.log('ERROR getPaymentFees', e);
    throw e;
  }
};

export const updatePaymentFees = async (storeId: string, data: {
  paymentFees: any[]
}) => {
  try {
    return await WashdayClientSingleton.getInstance().stores.updatePaymentFees(storeId, data);
  } catch (e) {
    console.log('ERROR updatePaymentFees', e);
    throw e;
  }
};
